import React from "react";
import { useSelector } from "react-redux";
import { getTreeSearch } from "../../reducers/search";
import FieldIcon from "./FieldIcon";
import { FieldVisibilityTypes } from "../../helpers/constants";
import highlightForSearch from "../../helpers/highlightForSearch";
import { IAppState } from "../../types/stores/index";
import FieldRateDisplay from "../admin/field-rates/FieldRateDisplay";
import DistributionCountsDisplay from "../admin/field-rates/DistributionCountsDisplay";
import FeatureGate from "../FeatureGate";
import TabGate from "../TabGate";
import { IField } from "../../types/stores/fieldTypes";

type Props = {
    fieldKey: string | number;
    TreeType?: number;
    tabType?: number;
    showTabs?: boolean;
};

const FieldListEntryText: React.FC<Props> = ({ fieldKey, TreeType, tabType, showTabs }: Props) => {
    const field = useSelector((state: IAppState) => {
        const fields =
            TreeType == FieldVisibilityTypes.EXPORT
                ? state.layoutfields
                : TreeType == FieldVisibilityTypes.REPORT
                  ? state.reportFields
                  : state.fields;

        if (fields.byId != null && fields.byId[fieldKey]) {
            return fields.byId[fieldKey];
        }

        const searchResults = state.vars.searchResults || {};
        const fromSearchResults = Object.values(searchResults).find(
            (f: IField) => f && (f.fieldkey === fieldKey || f.workid === fieldKey)
        );

        return fromSearchResults || "";
    });
    const treeSearch = useSelector((state: IAppState) => getTreeSearch(state));

    if (!field) {
        return <span>(unknown field)</span>;
    }
    const icon = <FieldIcon field={field} />;
    const externalIcon = field.IsPII ? <i className="material-icons-cloud">cloud</i> : null;
    const displayText = highlightForSearch(field.text, treeSearch);

    return (
        <span className="field-list-entry-text" style={{ marginLeft: "-5px" }}>
            {icon} {externalIcon} {displayText}{" "}
            <span className="field-list-entry-text" style={{ fontSize: 12 + "px" }}>
                {" "}
                <DistributionCountsDisplay field={field}></DistributionCountsDisplay>
                <FeatureGate feature={["display-field-rates", "field-tree-tabs"]}>
                    <TabGate tabType={tabType} showTabs={showTabs}>
                        {" "}
                        <FieldRateDisplay field={field}></FieldRateDisplay>
                    </TabGate>
                </FeatureGate>
            </span>
        </span>
    );
};

export default FieldListEntryText;
